export default __webpack_public_path__ + "static/media/pantry1-afterB-2048w.e9021992.webp";